import { Divider, Link } from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';
import { MessagingProvider } from '@src/model/frontendmodel';
import { ChatMessageAdPayload } from '@src/types';
import { useMemo, useState } from 'react';

type ChatMessageAdProps = {
  adPayload: ChatMessageAdPayload;
  provider?: string;
};

const ChatMessageAd: React.FC<ChatMessageAdProps> = ({
  adPayload,
  provider,
}) => {
  const imageUrl = useMemo(() => {
    switch (adPayload?.mediaType) {
      case 'image':
        return adPayload?.imageUrl;
      case 'video':
        return adPayload?.thumbnailUrl;
      default:
        return null;
    }
  }, [adPayload]);

  const allowOpenNewTab =
    adPayload.sourceType !== 'post' && provider !== MessagingProvider.INSTAGRAM;

  const [isLoadedImage, setIsLoadedImage] = useState(false);

  return (
    <div className="ChatMessageAd">
      <div className="ChatMessageAdType">
        {adPayload.sourceType === 'ad' && 'AD'}
        {adPayload.sourceType === 'post' && 'POST'}
      </div>

      {imageUrl && (
        // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
        <div
          className="ChatMessageMedia"
          style={{ cursor: allowOpenNewTab ? 'pointer' : '' }}
          onClick={() => {
            if (allowOpenNewTab) window.open(adPayload.sourceUrl);
          }}
        >
          {!isLoadedImage && (
            <Skeleton
              variant="rect"
              width={330}
              height={400}
              style={{ borderRadius: 5, backgroundColor: '#d7d7da' }}
            />
          )}
          <img
            src={imageUrl}
            alt={adPayload?.headline}
            onLoad={() => setIsLoadedImage(true)}
            style={{
              display: isLoadedImage ? 'block' : 'none',
              maxHeight: 400,
            }}
            onError={e => {
              e.currentTarget.src = '/images/notImage.png';
            }}
          />
        </div>
      )}

      <div className="ChatMessageAdContent">
        <div className="ChatMessageAdContentHead">{adPayload.headline}</div>
        <div className="ChatMessageAdContentBody">{adPayload.body}</div>
        <Link href={adPayload.sourceUrl} target="_blank">
          {adPayload.sourceUrl}
        </Link>
      </div>
      <Divider style={{ margin: '8px 0' }} />
    </div>
  );
};

export default ChatMessageAd;
